var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:this.amount,staticClass:"suchprice"},[_c('span',{class:this.getClasses,style:(this.happStyle())},[_vm._v(_vm._s(this.amount))])])}
var staticRenderFns = []

export { render, staticRenderFns }